export default __webpack_public_path__ + "static/media/infoIcon.7ff778a0.svg";